"use client";
import Combobox from "@/components/primitives/combobox";
import { Team } from "common";
import { useRouter } from "next/navigation";
import React from "react";

export default function InjuriesFilter({
  teams,
  team,
}: {
  teams: Team[];
  team: string;
}) {
  const router = useRouter();
  const teamOptions: Option[] = [
    { label: "All Teams", value: "all" },
    ...teams.map((team) => ({
      label: `${team.location} ${team.name}`,
      value: `${team.location.toLowerCase()} ${team.name.toLowerCase()}`,
    })),
  ];

  return (
    <Combobox
      triggerPlaceholder="Select Team"
      align="end"
      height={12}
      value={team}
      defaultValue={team}
      options={teamOptions}
      onSelectItem={(v) =>
        router.push(
          `?${new URLSearchParams({
            team: v,
          })}`,
          { scroll: false }
        )
      }
    />
  );
}
